import BaseParameterAction from './BaseParameterAction.js';

class UpdateParameterAction extends BaseParameterAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({parameter, value, automation=false, isBulk=false}) {
        if (parameter !== undefined) {
            parameter.set(value, automation, isBulk);
        }
    }

    undo({payload}) {
        payload.parameter.set(payload.savedValue);
    }

    getContentId(action) {
        return action.payload.parameter.id;
    }
}

export default UpdateParameterAction;
